import { getCurrentUser, fetchAuthSession } from '../util/amplifyAuth';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { tierFromGroups } from '../util/featureConfig';
import { checkTermsAccepted, checkFocuses } from '../components/API';

export function useAuth({ doctorViewMode = false } = {}) {
    const [user, setUser] = useState(undefined);
    const nav = useNavigate();

    useEffect(() => {
        const initAuth = async () => {
            try {
                const amplifyUser = await getCurrentUser();
                const data = { ...amplifyUser };

                // If not in doctor view mode, check if user is a doctor and redirect
                if (!doctorViewMode) {
                    const session = await fetchAuthSession();
                    const groups = session.tokens?.idToken?.payload['cognito:groups'] || [];
                    if (groups.includes('Doctors')) {
                        nav('/doctor');
                        return;
                    }

                    const { termsAccepted } = await checkTermsAccepted().catch(() => ({ termsAccepted: false }));
                    if (!termsAccepted) {
                        nav('/accept-terms', { replace: true });
                        return;
                    }

                    const skipUntil = localStorage.getItem('bloodeye_focus_skipped_until');
                    if (!skipUntil || Date.now() >= parseInt(skipUntil, 10)) {
                        const { hasFocuses } = await checkFocuses().catch(() => ({ hasFocuses: false }));
                        if (!hasFocuses) {
                            nav('/select-focus', { replace: true });
                            return;
                        }
                    }

                    const payload = session.tokens?.idToken?.payload;
                    data.email = payload?.email || '';
                    data.tier = tierFromGroups(groups);
                }

                setUser(data);
            } catch (err) {
                setUser(null);
            }
        };
        initAuth();
    }, []);

    // Redirect to landing if not authenticated (non-doctor view)
    useEffect(() => {
        if (user === null && !doctorViewMode) {
            nav("/");
        }
    }, [user]);

    return { user };
}
